import { render, staticRenderFns } from "./AccesoRestringido.vue?vue&type=template&id=27db3df2"
import script from "./AccesoRestringido.vue?vue&type=script&lang=js"
export * from "./AccesoRestringido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports